import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-status-square',
  templateUrl: './status-square.component.html',
  styleUrls: ['./status-square.component.sass']
})
export class StatusSquareComponent implements OnInit {
  @Input() status = '';
  @Input() small = false;

  constructor() { }

  ngOnInit() {
  }

  getClassName() {
    const status =  (this.status || '').toLowerCase().replace(/_/g, '-');

    return { [ 'status-square-' + status ]: true };
  }
}
